import { motion } from "framer-motion";
import { CHAPTERS } from "@/data/products";
import { Reveal } from "@/components/Reveal";

export default function Manifesto({ data }) {
  const chapters = data?.chapters?.length ? data.chapters : CHAPTERS;
  return (
    <section id="manifesto" data-testid="manifesto-section" className="border-t border-champagne/10 bg-pine/20 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">The Soonyoung Manifesto</p>
          <h2 className="mt-3 max-w-2xl font-display text-3xl leading-tight tracking-tight text-cream sm:text-5xl">
            Three chapters of <span className="italic text-gold">devotion</span>
          </h2>
        </Reveal>

        <div className="mt-8 space-y-12">
          {chapters.map((ch, i) => (
            <div
              key={ch.no}
              data-testid={`manifesto-chapter-${ch.no}`}
              className={`grid items-center gap-8 md:grid-cols-12 ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
            >
              <Reveal className="md:col-span-2 md:[direction:ltr]">
                <span className="font-display text-6xl italic text-stroke-gold sm:text-8xl">{ch.no}</span>
              </Reveal>
              <Reveal delay={0.1} className="md:col-span-6 md:[direction:ltr]">
                <h3 className="font-display text-2xl tracking-tight text-cream sm:text-4xl">{ch.title}</h3>
                <p className="mt-4 max-w-lg text-sm leading-relaxed text-sage sm:text-base">{ch.text}</p>
              </Reveal>
              <motion.div
                initial={{ opacity: 0, scale: 0.94 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="group relative aspect-[4/3] overflow-hidden rounded-2xl border border-champagne/10 md:col-span-4 md:[direction:ltr]"
              >
                <img
                  src={ch.img}
                  alt={ch.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-108"
                />
                <div className="absolute inset-0 bg-leaf/20 mix-blend-multiply" />
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
